class ClerkCartUpsells extends HTMLElement {
    constructor() {
        super();

        this.grid = this.querySelector('[data-clerk-grid]');

        this.call();
    }

    async call() {
        let endpoint = this.endpoint;

        const config = {
            key: window.integrations.clerk.key,
            labels: [`Cart drawer - ${this.endpoint}`],
            attributes: ["handle"]
        }

        if (this.keywords) config.keywords = this.keywords;
        if (this.limit) config.limit = this.limit;
        if (this.products) config.products = this.products;
        if (this.category) config.category = this.category;

        if (endpoint.includes('/customer/')) {
            if (this.email) {
                config.email = this.email;
            } else {
                endpoint = this.endpoint.replace('/customer/', '/visitor/')
            }
        }

        Clerk('call', endpoint, config,
            async (response) => {
                const productResponses = await Promise.all(response.product_data.map((product) => this.cachedFetch(`${Shopify.routes.root}products/${product.handle}?view=clerk-item`, 'text')));
                this.grid.innerHTML = productResponses.filter(i => !i.includes('<head')).map((productItem) => {
                    return productItem.replaceAll('product-quick-buy----', `product-quick-buy-clerk-cart-upsell--`);
                }).join('');
                this.grid.hidden = false;
                Clerk("click", "*[data-clerk-product-id]");
            },
            () => {
                this.remove();
            })
    }

    cachedFetch(url, type = 'json') {
        return new Promise(async (resolve) => {
            if (sessionStorage.getItem(`clerk-search-${url}`)) {
                resolve(type === 'json' ? JSON.parse(sessionStorage.getItem(`clerk-search-${url}`)) : sessionStorage.getItem(`clerk-search-${url}`));
            } else {
                const response = await fetch(url).then(r => {
                    if (type === 'json') {
                        return r.json();
                    } else {
                        return r.text()
                    }
                });

                if (type === "text") {
                    if (!response.includes('<head')) sessionStorage.setItem(`clerk-search-${url}`, response);
                } else sessionStorage.setItem(`clerk-search-${url}`, type === 'json' ? JSON.stringify(response.results.products) : response);
                resolve(type === 'json' ? response.results.products : response)
            }
        })
    }

    get limit() {
        return parseInt(this.getAttribute('limit'));
    }

    get endpoint() {
        return this.getAttribute('endpoint');
    }

    get category() {
        return this.getAttribute('category');
    }

    get keywords() {
        return this.getAttribute('keywords');
    }

    get email() {
        return this.getAttribute('email');
    }

    get products() {
        return this.getAttribute('products') ? this.getAttribute('products').split(',') : null;
    }

    get visitor() {
        return window.sessionStorage.getItem('visitor_id') || 'auto';
    }
}

if (!window.customElements.get("clerk-cart-upsells")) {
    window.customElements.define("clerk-cart-upsells", ClerkCartUpsells);
}